<template>
  <div class="d-flex flex-column ga-6 overflow-auto">
    <div class="title">
      {{$t('Изображение профиля')}}
    </div>
    <div class="d-flex flex-column ga-4 align-center">
      <label :for="saving ? undefined : 'inputField'">
        <v-avatar size="200" :icon="AddAvatarIcon" :image="currentImage" color="BW-100-BG" class="cursor-pointer"></v-avatar>
      </label>
    </div>
    <div class="d-flex flex-column ga-2">
      <v-btn variant="outlined" color="accent" rounded="lg" tag="label" for="inputField" class="w-100" v-if="!currentImage" :loading="saving" :disabled="saving">
        {{$t('Добавить')}}
      </v-btn>
      <template v-else>
        <v-btn variant="outlined" color="accent" rounded="lg" tag="label" for="inputField" class="w-100" :loading="saving" :disabled="saving">
          {{$t('Заменить')}}
        </v-btn>
        <v-btn variant="outlined" color="accent" rounded="lg" @click="clearImage" class="w-100" :disabled="saving">
          {{$t('Удалить')}}
        </v-btn>
      </template>
    </div>
    <div v-if="uploadError" class="text-error text-center" role="alert">{{ $t('Не удалось загрузить изображение') }}</div>
  </div>
  <ImageCropper @upload="setImage($event)" :compress="true"/>
</template>

<script setup lang="ts">
import {onBeforeUnmount, onMounted, ref} from "vue";
import {useTapStore} from '@/stores/tapStore';
import {useDialogStore} from "@/stores/dialogStore";
import AddAvatarIcon from "~/assets/icons/add-avatar.vue";

const tapStore = useTapStore();
const dialogStore = useDialogStore()
const currentImage = ref('')
const saving = ref(false)
const uploadError = ref(false)
let active = true
onBeforeUnmount(() => {active = false})

const updateImage = async (image) => {
  if (saving.value || !active) return false
  const previousImage = currentImage.value
  currentImage.value = image
  uploadError.value = false
  saving.value = true
  try {
    await tapStore.setImage(image)
    return true
  } catch {
    currentImage.value = previousImage
    uploadError.value = true
    return false
  } finally {
    saving.value = false
  }
}

const setImage = async (image) => {
  if (await updateImage(image) && active) dialogStore.close()
}

const clearImage = () => updateImage(null)

onMounted(() => {
  currentImage.value = tapStore.currentTap?.image
})
</script>

<style scoped lang="sass">
.title
  color: #363636
  text-align: center
  font-size: 20px
  font-weight: 600
  line-height: normal
</style>
